import { useState, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export function useFormConfirmed<SuccessData>() {
  const location = useLocation()
  const navigate = useNavigate()
  const [successData, setSuccessData] = useState<SuccessData | null>(null)

  const isConfirmed = location.hash === '#confirmed'

  const confirmForm = useCallback(
    (data: SuccessData) => {
      setSuccessData(data)
      navigate(location.pathname + '#confirmed')
    },
    [location.pathname, navigate],
  )

  return {
    pathname: location.pathname,
    successData,
    isConfirmed,
    confirmForm,
  }
}
